"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAnalyticsParamsForDataCenter = getAnalyticsParamsForDataCenter;
var _crossPlatformDelivery = require("./crossPlatformDelivery");
function getAnalyticsParamsForDataCenter(config, castleEnabled, engenciaIntegration) {
  var dataCenterLocation = (0, _crossPlatformDelivery.parseDataCenterFromXpdManifestName)(config);
  var amexStatus = castleEnabled ? 'amex_complete' : 'non_amex_complete';
  var egenciaStatus = engenciaIntegration ? 'egencia_integrated' : 'no_egencia_integration';
  var analyticsParams = {};
  switch (dataCenterLocation) {
    case 'default':
    case 'dev':
    case 'impl-us':
    case 'integration':
      analyticsParams = {
        region: 'us',
        productDataCenterSiteTypeOS: "cte:na:web:web:".concat(amexStatus, ":").concat(egenciaStatus),
        analyticsInstance: 'dev-us',
        manualPing: 'manual_ping_nui'
      };
      break;
    case 'impl-eu':
      analyticsParams = {
        region: 'eu',
        productDataCenterSiteTypeOS: "cte:eu:web:web:".concat(amexStatus, ":").concat(egenciaStatus),
        analyticsInstance: 'dev-eu',
        manualPing: 'manual_ping_nui'
      };
      break;
    case 'preview-gov':
      analyticsParams = {
        region: 'us',
        productDataCenterSiteTypeOS: "gov:na:web:web:".concat(amexStatus, ":").concat(egenciaStatus),
        analyticsInstance: 'dev-gov-us',
        manualPing: 'manual_ping_nui_gov'
      };
      break;
    case 'prod-us':
    case 'prod-us2':
      analyticsParams = {
        region: 'us',
        productDataCenterSiteTypeOS: "cte:na:web:web:".concat(amexStatus, ":").concat(egenciaStatus),
        analyticsInstance: 'us',
        manualPing: 'manual_ping_nui'
      };
      break;
    case 'prod-eu':
    case 'prod-eu2':
      analyticsParams = {
        region: 'eu',
        productDataCenterSiteTypeOS: "cte:eu:web:web:".concat(amexStatus, ":").concat(egenciaStatus),
        analyticsInstance: 'eu',
        manualPing: 'manual_ping_nui'
      };
      break;
    case 'prod-gov':
    case 'prod-pscc':
      analyticsParams = {
        region: 'us',
        productDataCenterSiteTypeOS: "gov:na:web:web:".concat(amexStatus, ":").concat(egenciaStatus),
        analyticsInstance: 'gov-us',
        manualPing: 'manual_ping_nui_gov'
      };
      break;
    case 'prod-apj1':
      analyticsParams = {
        region: 'apac',
        productDataCenterSiteTypeOS: "cte:jp:web:web:".concat(amexStatus, ":").concat(egenciaStatus),
        analyticsInstance: 'apac',
        manualPing: 'manual_ping_nui'
      };
      break;
    default:
      break;
  }
  return analyticsParams;
}